module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3wGGV"))).then(() => parcelRequire('d0iPb'));